import { controlledDialogHOC } from "./controlledDialogHOC";
import Dialog from "@material-ui/core/Dialog";

export default controlledDialogHOC(Dialog);
